<template>
  <section class="latestOffers defaultSectionMargins">
    <div class="container">
      <div class="latestOffers__Top">
        <h2 v-text="data.title" />
        <div>
          <Button type="nuxt-link" :to="link('OfferList')" secondary medium>{{ $t('seeAll') }}</Button>
        </div>
      </div>

      <FlickitySlider with-progress class="latestOffers__Grid" :options="flickityOptions">
        <OfferItem v-for="item in offerItems" :data="item.offer" class="latestOffers__GridItemOuter" />
      </FlickitySlider>
    </div>
  </section>
</template>

<script setup>
  const { link } = useSetup();

  const props = defineProps({
    data: {},
  });

  const offerItems = computed(() => props.data.items.slice(0, 5));

  const flickityOptions = {
    pageDots: false,
    prevNextButtons: false,
    watchCSS: true,
    cellAlign: 'left',
  };
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_latestOffers.scss');
</style>